import { useCallback, useReducer } from "react";

import { onSignUp } from "../services/auth";
import { SignUpForm } from "../interfaces/auth";

interface UseSignUp {
  loading: boolean;
  userExist: boolean;
  error: boolean;
  success: boolean;
}

interface Action {
  type: "loading" | "userExist" | "error" | "success";
  value?: any;
}

const initialState = {
  loading: false,
  userExist: false,
  error: false,
  success: false,
} as UseSignUp;

const reducer = (state: UseSignUp, action: Action) => {
  switch (action.type) {
    case "loading":
      return {
        ...state,
        loading: action.value,
      };
    case "userExist":
      return {
        ...state,
        userExist: action.value,
      };
    case "success":
      return {
        ...state,
        success: action.value,
      };
    case "error":
      return {
        ...state,
        error: action.value,
      };
    default:
      return state;
  }
};

export const useSignUp = (fields: SignUpForm, cb = (value: any) => {}) => {
  const [{ loading, userExist, error, success }, dispatch] = useReducer(
    reducer,
    initialState
  );

  const onSignUpHandle = useCallback(() => {
    dispatch({ type: "loading", value: true });
    onSignUp(fields)
      .then(({ data }) => {
        dispatch({ type: "loading", value: false });
        dispatch({type: 'success', value: true});
      })
      .catch((err) => {
        const { response } = err;
        if (response.data) {
          const { name } = response.data;
          if (name === 'USER_EXIST') {
            dispatch({type: 'userExist', value: true});
          } 
        } else {
          dispatch({ type: "error", value: true });
        }
        dispatch({ type: "loading", value: false });
      });
  }, [fields, cb]);

  return {
    loading,
    success,
    error,
    userExist,
    onSignUpHandle,
    setLoading: (cb: () => boolean) =>
      dispatch({ type: "loading", value: cb() }),
    cancelError: () => dispatch({ type: "error", value: false }),
    cancelSuccess: () => dispatch({ type: "success", value: false }),
    cancelUserExist: () => dispatch({ type: "userExist", value: false })
  };
};
